import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Quote, X } from 'lucide-react';
export function FounderSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      <section id="founder" className="py-20 bg-[#F5F0E8]" data-id="element-262">
        <div className="container mx-auto px-4" data-id="element-263">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-264">
            {/* Image Side */}
            <div className="w-full lg:w-5/12" data-id="element-265">
              <div className="relative" data-id="element-266">
                <div className="absolute top-4 left-4 w-full h-full border-2 border-[#D4A843] rounded-lg transform translate-x-4 translate-y-4 z-0" data-id="element-267" />
                <img src="https://cdn.magicpatterns.com/uploads/fLwftKZJHYHmq983KNfD5Y/photo_2026-02-13_11-38-22.jpg" alt="Олена Водолажко — засновниця" className="relative z-10 w-full h-auto rounded-lg object-cover shadow-lg" data-id="element-268" />
              </div>
            </div>

            {/* Content Side */}
            <div className="w-full lg:w-7/12" data-id="element-269">
              <div className="relative" data-id="element-270">
                <Quote className="absolute -top-10 -left-6 text-[#D4A843]/20 w-24 h-24 rotate-180" data-id="element-271" />

                <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-8 relative z-10" data-id="element-272">
                  Звернення засновниці
                </h2>

                <div className="space-y-6 text-lg text-gray-700 relative z-10" data-id="element-273">
                  <p data-id="element-274">Привіт усім!</p>
                  <p data-id="element-275">
                    Мене звати Олена Водолажко. Я адвокат, юрист з великим
                    досвідом в регулюванні сфери азартних ігор та лотерей.
                  </p>
                  <p data-id="element-276">
                    Я запрошую Вас у ПРОСТІР ЧЕСНОЇ ГРИ, який я створила для
                    всіх, хто хоче і буде робити азарт в Україні чесним і
                    відповідальним, для тих, хто хоче грати ЧЕСНО і
                    відповідально, для тих, хто буде ЧЕСНО говорити про
                    залежність і ЧЕСНО допомагати тим, кому потрібна допомога і
                    підтримка в боротьбі із залежністю.
                  </p>
                  <p data-id="element-277">
                    Це ПРОСТІР для ЧЕСНОГО діалогу, підтримки, освіти,
                    досліджень і розвитку сфери азартних ігор і кожного, хто
                    приєднається до нього.
                  </p>
                  <p data-id="element-278">Ласкаво прошу!</p>
                </div>

                <div className="mt-10 mb-8" data-id="element-279">
                  <div className="text-lg text-gray-700" data-id="element-280">З повагою,</div>
                  <div className="text-2xl font-serif font-bold text-[#0A5E5C] mt-2" data-id="element-281">
                    Олена Водолажко
                  </div>
                  <div className="text-[#D4A843] font-medium mt-1" data-id="element-282">
                    Засновниця
                  </div>
                </div>

                <Button variant="primary" size="lg" onClick={() => setIsModalOpen(true)} data-id="element-283">
                  Прочитати більше
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {isModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setIsModalOpen(false)} data-id="element-284">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-285" />

          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-286">
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-287">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-288">
                Звернення засновниці
              </h3>
              <button onClick={() => setIsModalOpen(false)} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-289">
                <X className="w-5 h-5" data-id="element-290" />
              </button>
            </div>

            <div className="p-6 md:p-8 space-y-5 text-gray-700 leading-relaxed" data-id="element-291">
              <p data-id="element-292">Вітаю всіх у Просторі Чесної ГРИ!</p>

              <p data-id="element-293">
                Чесність із самим собою — це та передумова, без якої, на мій
                погляд, майже неможливо йти вперед і розвиватися.
              </p>

              <p data-id="element-294">
                Чесність я вважаю запорукою усвідомленості, свободи, мудрості та
                гармонії, і чесність — це завжди вибір.
              </p>

              <p data-id="element-295">
                Обрати бути чесним із собою і зі світом буває важко і боляче,
                але це єдиний можливий шлях взяти відповідальність за своє
                життя, чесно визнавати помилки, якщо вони є, виправити їх і йти
                до цілісності і процвітання.
              </p>

              <p data-id="element-296">
                Чесність сьогодні надзвичайно потрібна для сфери азартних ігор в
                Україні.
              </p>

              <p data-id="element-297">
                Мій глибокий професійний досвід, практичні знання в сфері
                регулювання азартних ігор, в різних галузях юриспруденції,
                психології, а також мій вибір бути чесною із собою і світом
                надихнули мене на створення якісно нового Простору, який би
                поєднав всіх, хто готовий долучитися до ініціативи, яка
                сприятиме чесності та прозорості у сфері азартних ігор в
                Україні.
              </p>

              <p data-id="element-298">
                Чесність і прозорість в цій сфері є фундаментально важливими для
                становлення усвідомленого ставлення суспільства до азартних
                ігор, для формування високої культури споживання в цій сфері,
                зокрема, серед дітей та молоді, для захисту прав гравців, а
                також для дієвої допомоги тим, хто з якихось причин став
                залежним від гри.
              </p>

              <p data-id="element-299">
                Так сталося, що в нашому суспільстві сьогодні про азартні ігри і
                про все, що з цим пов'язано, мовчать, бо це щось таке, що як
                правило, викликає осуд, сором, негатив, засудження, гнів,
                неприйняття тощо. А тому, краще про це мовчати, уникати, не
                приймати, відвертатися і ховати.
              </p>

              <p data-id="element-300">
                І це можна залишити як є, але це і є причиною, яка залишає після
                легалізації цю сферу незрозумілою, непрозорою, навіть
                демонізованою, а іноді небезпечною для тих, хто через брак
                інформації та знань, відсутність розуміння і підтримки стає
                залежним і залишається наодинці з цією залежністю в соромі і
                вині.
              </p>

              <p data-id="element-301">
                Впевнена, що чесність і готовність чесно говорити про азартні
                ігри, про те, що це таке, і про все, що з цим пов'язано,
                поєднані із знанням, освітою, співпрацею, взаємопорозумінням та
                людяністю змінять і саму сферу азартних ігор і зроблять її
                зрозумілою та безпечною для суспільства.
              </p>

              <p data-id="element-302">
                В цьому Просторі кожен, хто зробить вибір бути чесним зможе
                знайти своє місце, свою реалізацію, знання, корисну інформацію,
                інструменти захисту своїх прав, методики, а також підтримку і
                розуміння.
              </p>

              <p data-id="element-303">
                Я запрошую всіх, хто розділяє цінності і місію Простору Чесної
                Гри до співпраці та партнерства.
              </p>

              <p data-id="element-304">
                А також запрошую до нашого Простору всіх, хто зацікавлений
                дізнатися чесну інформацію про азартні ігри, про залежність від
                них, про те, як можна допомогти собі або близьким людям.
              </p>

              <p data-id="element-305">
                Я запрошую Вас разом навчатися, досліджувати, пізнавати,
                підтримувати один одного, щоб вибір бути чесним із собою і
                світом був легким і усвідомленим.
              </p>

              <div className="pt-4 border-t border-gray-100" data-id="element-306">
                <p data-id="element-307">З глибокою повагою і найкращими побажаннями!</p>
                <p className="font-serif font-bold text-[#0A5E5C] text-lg mt-2" data-id="element-308">
                  Олена Водолажко
                </p>
                <p className="text-[#D4A843] font-medium" data-id="element-309">Засновниця FGS</p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}